import React from 'react';
import { Link } from 'gatsby';
import { getKeyFromString } from '../utils/utils.js';

export default function CourseTopicSelector(props) {
  return (
    <div className="container course-topic-selector-frontpage mt-6 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <p key="first" className="mb-4 lead">
            Tarvitsetko sujuvuutta Excelin tai muiden Office-ohjelmien käyttöön?
            Haluatko saada aikaan säästöjä kouluttamalla henkilöstöäsi?
          </p>
          <p key="second" className="mb-0 lead">
            Officekoulutus tarjoaa Exceliin ja muihin Office-aiheiseen sekä
            prosessien tehostamiseen ja testausautomaatioon liittyvää koulutusta
            ja konsultointia.
          </p>
        </div>
        <div className="col-md-12">
          <div className="list mt-5 mb-2">
            {props.topics.map((item, index) => {
              return (
                <React.Fragment
                  key={getKeyFromString(item.title + '--fragement')}
                >
                  <Link
                    className="btn btn-primary list-item-wrapper mx-3 p-2"
                    to={'/' + item.link}
                    key={getKeyFromString(item.title)}
                  >
                    {/* <div className="item"><Link to={"/" + item.link} key={getKeyFromString(item.title)}>{item.title}</Link></div> */}
                    <div className="item">{item.title}</div>
                  </Link>
                  <div
                    className="flex-break d-lg-none"
                    key={getKeyFromString(item.title) + '--line-break'}
                  ></div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
